import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';


@Component({
  selector: 'app-information-dialog',
  templateUrl: './information-dialog.component.html',
  styleUrl: './information-dialog.component.scss'
})
export class InformationDialogComponent {
  loadingModal: boolean = false
  model: any = {
    title: '¿Confirma realizar la acción?',
    description: '',
    confirmText: 'Confirmar',
    warning: true,
    error: false
  };

  constructor( 
    @Inject(MAT_DIALOG_DATA) 
    public data: any, 
    public dialogRef: MatDialogRef<InformationDialogComponent>) {
    if(data){
      this.model = Object.assign(this.model, data)
    }
  }

  ngOnInit() { }

  cancel() {
    this.dialogRef.close({exito: false});
  }
  
  confirm(){
    this.loadingModal = true
    this.dialogRef.close({exito: true});
  }
}
